import { Injectable } from '@angular/core';
import { JoinRoleComponent } from './join-role/join-role.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class RoleUIService {

  constructor(
    private dialog: MatDialog
  ) { }

  public openJoinRole(assignedSchoolDSNS?: string) {
    this.dialog.open(JoinRoleComponent, {
      width: 'calc(100vw - 24px)',
      maxWidth: '52.5rem',
      maxHeight: 'calc(100dvh - 24px)',
      autoFocus: 'dialog',
      ariaLabelledBy: 'join-role-title',
      data: {
        assignedSchoolDSNS
      }
    });
  }
}
